// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_COMMENT_VIOLATES_RULES = "Nahl\u00e1s nevhodn\u00fa odpove\u010f";
export const SEO_TITLE_BLOGS_SHORT_MESSAGE_OF_username = "Kr\u00e1tka spr\u00e1va pou\u017e\u00edvate\u013eky %(username)s";
